import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { WpConfigService } from '../wp-config/wp-config.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WpApiService {
  constructor(
    private configService: ConfigService,
    private wpConfigService: WpConfigService,
    private communicationConfigService: CommunicationConfigService,
    private http: HttpClient
  ) {}

  getNavMenu(): Observable<any[]> {
    if (this.configService.getOptions()) {
      return of([
        {
          text: 'Nos formations',
          items: [
            {
              text: 'Catalogue',
              path: '/catalog',
              items: []
            },
            {
              text: 'Ma selection',
              path: '/cart',
              items: []
            }
          ]
        },
        {
          text: 'Implantation',
          items: [
            {
              text: 'Les centres de formation Socotec',
              path: 'http://www.formation-socotec.fr/106-Coordonnees-des-Centres.html '
            }
          ]
        },
        {
          text: 'Nous connaître',
          path: 'http://www.formation-socotec.fr/101-Le-cadre-d-enseignement-des-formations-SOCOTEC.html ',
          items: []
        },
        {
          text: 'Nous contacter',
          items: [
            {
              text: 'Espace client',
              path: '/account',
              items: []
            }
          ]
        }
      ]);
    } else {
      return this.http.get<any[]>(`${this.communicationConfigService.getApiUri()}/wp-api/navigation`);
    }
  }
}
